<template>
    <div id="gwi-profile" class="app">
        <scroll class="voucher-qr-code" @refresh="refresh">
            <section class="row">
                <button id="profile-btn-addVoucher" class="btn-ok" type="button" :disabled="3 === voucherList.length" @click="goAddVoucher">办卡/绑卡</button>
                <p class="f-minor text-center mytips">
                    <span id="profile-span-full" v-if="3 === voucherList.length">就诊凭证已满，如需绑定请先解绑其他就诊凭证</span>
                    <span id="profile-span-empty" v-else-if="0 === voucherList.length">请先办理或绑定就诊凭证</span>
                    <span id="profile-span-normal" v-else>还能绑定<span id="profile-span-surplus" class="mygray">{{3 - voucherList.length}}</span>张就诊凭证</span>
                </p>
            </section>
            <voucher-item :id="'profile-voucherItem-' + voucher.cardNo" class="voucher-list" v-for="(voucher, index) in voucherList" :key="index" :class="(0 === index) ? 'selected' : ''" :voucher="voucher" :edit="0" @selected="selectVoucher(voucher, index, $event)" :is-frequent="index === 0"></voucher-item>
        </scroll>
    </div>
</template>
<script>
import voucherService from 'voucher.service'
import VoucherItem from '../voucher/VoucherItem'

export default {
    components: {
        VoucherItem
    },
    data() {
        return {
            voucherList: []
        }
    },
    created() {
        this.refresh()
    },
    methods: {
        refresh() {
            voucherService.getVoucherList().then((res) => {
                if (res.resultCode !== this.constant.RESULT_SUCCESS) {
                    this.$utils.alert(res.resultMsg)
                    return
                }
                this.voucherList = res.data
            })
        },
        selectVoucher(voucher) {
            this.$store.commit('updateParam', {
                namespace: 'detail',
                voucher: voucher
            });
            this.$router.push('voucherDetail');
        },
        goAddVoucher() {
            this.$router.push('voucherChooseType');
        }
    },
}
</script>
<style lang="scss">
    @import '../../../static/sass/_variable.scss';
    .scroll.voucher-qr-code {
        .btn-ok {
            &:disabled {
                background: #ccc;
                color: #fff;
                box-shadow: none;
            }
        }
        .mytips {
            margin-top: 13px;
            .mygray {
                color: #333;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// VoucherQrCode.vue?249b77a6